import router from 'src/router'
import {
    TweenLite
} from 'gsap'
import Dot from 'src/components/swipecta/dot'

class Arrow {

    constructor(config) {

        this.tweenObj = {
            alpha: 0
        };

        this.ctx = config.ctx;
        this.lineWidth = config.lineWidth;
        this.pixelRatio = config.pixelRatio;
        this.radius = config.radius;
        this.points = config.points;
        this.padding = config.padding;
        this.progress = config.progress;
        this.NUM_OF_DOTS = config.NUM_OF_DOTS;
 
        this.dots = [];
        for (var i = 0; i < this.NUM_OF_DOTS; i++) {
            this.dots.push(new Dot(config));
        }
    }

    draw(progress) {

        this.ctx.save();

        let numOfDots = Math.round((1 - progress) / (1 / this.NUM_OF_DOTS));
        for (var i = 0; i < this.dots.length; i++) {

            let dot = this.dots[i];
            if (i >= numOfDots) {
                dot.inactive();
            } else {
                dot.active();
            }

            this.dots[i].draw(i);
        }

        this.ctx.restore();
    }

    show() {
        for (var i = 0; i < this.dots.length; i++) {
            let delay = 0.5 + (this.dots.length - i) * 0.1;
            this.dots[i].show(delay);
        } 
    }


    // input states

    up() {
      for (var i = 0; i < this.dots.length; i++) { 
            this.dots[i].up();
        }
    }

    down() {
      for (var i = 0; i < this.dots.length; i++) { 
            this.dots[i].down();
        } 
    }
}

export default Arrow